import { useTranslation } from 'react-i18next';
import { Music, Video } from 'lucide-react';
import type { MediaType } from '@/domain/model/MediaType';
import { mediaTypeLabelKey } from '@/presentation/util/mediaType';

interface MediaTypeLabelProps {
  mediaType: MediaType | null;
}

export const MediaTypeLabel = ({ mediaType }: MediaTypeLabelProps) => {
  const { t } = useTranslation();

  if (!mediaType) {
    return null;
  }

  const Icon = mediaType === 'AUDIO' ? Music : Video;

  return (
    <span className="flex items-center gap-1">
      <Icon className="h-3.5 w-3.5" />
      {t(mediaTypeLabelKey(mediaType))}
    </span>
  );
};
